import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    Marker,
    Snackbar,
    Map,
    Route,
    LayersControler,
    LayersGroup
} from 'sm-react-components';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import { createClusterCustomIcon } from '../formatters';

const styles = {
    noLogs: {
        padding: '10px'
    },
    content: {
        height: '300px'
    },
    snackbarRoot: {
        position: 'absolute',
        top: '-20%'
    }
};

class RequestsMapPlaces extends Component {
  state = {
      status: undefined,
      processing_time: undefined,
      selected: undefined,
      snackbarOpen: false,
      places: undefined,
      placesNotVisited: undefined
  };

  handleSelectRoute = route => {
      const { onRouteSelected } = this.props;
      this.setState({
          selected: route
      });
      onRouteSelected && onRouteSelected(route);
  };

  handleSelectPlace = place => {
      const { onPlaceSelected } = this.props;
      this.setState({
          selected: place
      });
      onPlaceSelected && onPlaceSelected(place);
  };

  generateSuccessState = (payload, response) => {
      // MAP ALL POINTS
      const places = [];
      const placesNotVisited = [];

      response.places &&
      Object.values(response.places).forEach(place => {
          let durationDefault = 0;
          place.durations.forEach(duration => {
              if (duration.service_id === 'default') {
                  durationDefault = duration.mean;
              }
          });
          if (place.visit_count > 0) {
              places.push({
                  location: place.location,
                  parkings: place.coordinates,
                  type: 'place',
                  id: place.id,
                  duration: durationDefault,
                  timewindows: place.timewindows,
                  visitcount: place.visit_count,
                  place
              });
          } else {
              placesNotVisited.push({
                  location: place.location,
                  parkings: place.coordinates,
                  type: 'place',
                  id: place.id,
                  duration: durationDefault,
                  timewindows: place.timewindows,
                  visitcount: place.visit_count,
                  place
              });
          }
      });
      const routes =
      payload.routes &&
      payload.routes.map((route, idx) => ({
          id: route.driver_id || idx, // ESTA AIXI PERO SI NO CANVIA SHA DE CANVIAR
          type: route.device_type,
          duration:
          route.traces[route.traces.length - 1].timestamp -
          route.traces[0].timestamp,
          steps: route.traces.map(trace => ({
              lat: trace.lat,
              lng: trace.lng
          }))
      }));
      this.setState({
          places,
          routes,
          placesNotVisited
      });
  };

  generateErrorState = () => {
      this.setState({
          places: undefined,
          placesNotVisited: undefined
      });
  };

  generatePlaces = request => {
      const { payload, response } = request;

      if (!response) {
          this.generateErrorState();
      } else if (response.status === 'success') {
          this.generateSuccessState(payload, response);
      }
  };

  componentDidMount() {
      const { request } = this.props;
      if (request) {
      // Generate the routes object
          this.generatePlaces(request);
          const { key, response } = request;
          if (response && key.testMode) {
              this.setState({
                  warning: `Test mode is enabled for this key.`,
                  snackbarOpen: true,
                  error: undefined
              });
          }
          // Check the status
          else if (key) {
              key.status === 'failed' &&
          this.setState({
              error: key.message,
              snackbarOpen: true,
              warning: undefined
          });
          }
      }
  }

  render() {
      const {
          places,
          placesNotVisited,
          routes,
          selected,
          error,
          snackbarOpen,
          warning
      } = this.state;
      const { height, classes } = this.props;
      const message = error ? error : warning;
      const variant = error ? 'error' : 'warning';
      return (
          <Fragment>
              <div style={{ position: 'relative' }}>
                  <Snackbar
                      variant={variant}
                      open={snackbarOpen}
                      onClose={() => this.setState({ snackbarOpen: false })}
                      horizontal="center"
                      vertical="top"
                      message={message}
                      classes={{ anchorOriginTopCenter: classes.snackbarRoot }}
                  />
                  <Map height={height || 540}>
                      <LayersControler>
                          <LayersGroup name="Visited" checked id="visited">
                              <MarkerClusterGroup
                                  disableClusteringAtZoom={17}
                                  iconCreateFunction={createClusterCustomIcon}
                              >
                                  {places &&
                    places.map((item, index) => {
                        const poiKey = 'places-poi-' + index;
                        const id = selected && selected.id;
                        return (
                            <Marker
                                key={poiKey}
                                onClick={() => this.handleSelectPlace(item)}
                                lat={item.location.lat}
                                lng={item.location.lng}
                                selected={item.id === id}
                                kind={item.type}
                                visited={item.visitcount > 0}
                            />
                        );
                    })}
                              </MarkerClusterGroup>
                          </LayersGroup>
                          <LayersGroup name="Unvisited" id="novisted">
                              {placesNotVisited &&
                  placesNotVisited.map((item, index) => {
                      const poiKey = 'places-poi-' + index;
                      const id = selected && selected.id;
                      return (
                          <Marker
                              key={poiKey}
                              onClick={() => this.handleSelectPlace(item)}
                              lat={item.location.lat}
                              lng={item.location.lng}
                              selected={item.id === id}
                              kind={item.type}
                              visited={item.visitcount > 0}
                          />
                      );
                  })}
                          </LayersGroup>

                          <LayersGroup name="Routes" checked id="routes">
                              {routes &&
                  routes.map((route, index) => [
                      <Marker
                          key={`markerStart_${index}`}
                          lat={route.steps[0].lat}
                          lng={route.steps[0].lng}
                          kind={'start'}
                          color={index}
                      />,
                      <Marker
                          key={`markerEnd_${index}`}
                          lat={route.steps[route.steps.length - 1].lat}
                          lng={route.steps[route.steps.length - 1].lng}
                          kind={'end'}
                          color={index}
                      />
                  ])}

                              {routes &&
                  routes.map((route, index) => {
                      const routeSelected = selected && selected.id === route.id;
                      const routeKey =
                      'route-' + route.id + (routeSelected ? '-selected' : '');
                      return (
                          <Route
                              key={routeKey}
                              path={route.steps}
                              color={index}
                              onClick={() => this.handleSelectRoute(route)}
                              selected={selected && selected.id === route.id}
                          />
                      );
                  })}
                          </LayersGroup>
                      </LayersControler>
                      {selected &&
              selected.parkings &&
              selected.parkings.map((parking, index) => {
                  return (
                      <Marker
                          key={'parkings-poi-' + index}
                          lat={parking.lat}
                          lng={parking.lng}
                          kind="parking"
                      />
                  );
              })}
                  </Map>
              </div>
          </Fragment>
      );
  }
}

export default withStyles(styles)(RequestsMapPlaces);
